<tax-page-header titleText="retailPlace.vpn.application"></tax-page-header>

<div class="subtitle">
  <div class="grey-text" data-qa="retail-place-name">
    {{ processForm?.fields?.retailPlaceTitle }}
  </div>
  <div class="grey-text retail-place-address" data-qa="retail-place-address">
    {{ processForm?.fields?.retailPlaceAddress?.fullAddress }}
  </div>
</div>

<div class="ui-kit-content-container" *ngIf="processForm">
  <tax-vpn-form
    *ngIf="processForm.formKey === 'retail-place-connect-vpn'"
    [retailPlaceData]="processForm.fields"
    (continueProcess)="goToSignStep($event)"
  ></tax-vpn-form>
  <!--TODO: fix $any-->
  <tax-vpn-sign
    *ngIf="processForm.formKey === 'sign-retail-place-vpn-annex'"
    [retailPlaceData]="$any(processForm.fields)"
  ></tax-vpn-sign>
</div>
